"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentEventType = void 0;
var SegmentEventType;
(function (SegmentEventType) {
    SegmentEventType["Identify"] = "identify";
    SegmentEventType["PageView"] = "pageView";
    SegmentEventType["Track"] = "track";
})(SegmentEventType || (exports.SegmentEventType = SegmentEventType = {}));
//# sourceMappingURL=types.js.map